import { fluidAdjusted } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
import brand from '@helpers/brand';
import MotionTrackStyles from '@stories/Components/Global/Carousel/MotionTrack/MotionTrack.styles';
import { m } from 'framer-motion';
import { paragraphSmall } from '@helpers/typography';
import ChevronDown from '@img/icons/chevron_down.svg?url';
import { NewsCardStyles } from '@stories/Components/Cards/NewsCard/NewsCard.styles';
import { transition } from '@helpers/animate';
const Container = styled.section `
  position: relative;
  display: block;
  overflow: hidden;
`;
const CardsGrid = styled(m.div).attrs(({ loading }) => ({
    initial: 'visible',
    animate: loading ? 'loading' : 'visible',
    variants: {
        loading: {
            opacity: 0.45,
        },
        visible: {
            opacity: 1,
        },
    },
})) `
  ${({ loading }) => loading &&
    css `
      pointer-events: none;
    `}
  gap: ${fluidAdjusted(32, 48, Device.Mobile, Device.ActualDesktop)};

  @media ${until(Device.TabletLarge)} {
    display: flex;
    flex-direction: column;

    ${() => NewsCardStyles.Container} {
      margin: auto;
    }
  }

  @media ${from(Device.TabletLarge)} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${from(Device.DesktopLarge)} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const FilterBar = styled.div `
  --visibleItems: 6;
  overflow: visible;
  margin-bottom: ${fluidAdjusted(35, 50, Device.Mobile, Device.ActualDesktop)};

  ${MotionTrackStyles.Track} {
    width: max-content;
  }
`;
const Filter = styled.div `
  padding-right: 20px;

  ${({ active }) => active &&
    css `
      ${FilterInner} {
        background-color: ${brand.black};
        color: ${brand.white};
        font-weight: 600;
      }
    `}
`;
const FilterInner = styled.button `
  font-family: var(--fontFamily);
  font-size: ${fluidAdjusted(18, 20, Device.Mobile, Device.ActualDesktop)};
  line-height: ${fluidAdjusted(28, 36)};
  font-weight: 300;
  letter-spacing: -0.024em;

  ${transition('background-color')};
  border: none;
  border-radius: 100px;
  padding: 8px 20px 12px;
  background-color: ${brand.grey.grey90};
  color: ${brand.black};
  width: max-content;
  max-width: 100%;
  transition: all 0.25s ease-in-out;
  cursor: pointer;

  @media ${from(Device.TabletLarge)} {
    font-weight: 300;
  }

  &:hover {
    background-color: ${brand.grey.grey60};
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: currentColor;
  }
`;
const PaginationWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 55px 0px 30px;
`;
const SortBar = styled.div `
  margin: 25px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${until(Device.TabletLarge)} {
    flex-direction: column;
  }
`;
const Count = styled.div `
  ${paragraphSmall};

  span {
    font-weight: 700;
  }
`;
const SortBy = styled.select `
  font: inherit;
  padding: 21px 65px 21px 24px;
  font-weight: 100;
  outline: none;
  border: 2px solid ${brand.black};
  border-radius: 10px;
  background-color: ${brand.white};
  background-image: url('${ChevronDown}');
  background-repeat: no-repeat;
  background-size: 15px;
  background-position: calc(100% - 25px) center;

  @media ${until(Device.TabletLarge)} {
    width: 100%;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: currentColor;
  }

  // Attempt to hide the arrow //
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
`;
export const NewsListingStyles = {
    Container,
    CardsGrid,
    FilterBar,
    Filter,
    FilterInner,
    PaginationWrapper,
    SortBar,
    Count,
    SortBy,
};
